<template>
  <div class="ty-content white">
    <el-form :inline="true" class="query-form" :model="form" onsubmit="return false;" style="text-align: left;">
      <el-form-item label="员工:">
        <el-input
          v-model="form.user_list"
          placeholder="请选择员工"
          @focus="openSelectDialog"
          clearable
          @clear="setValueNull"
        ></el-input>
      </el-form-item>
      <el-form-item label="部门:">
        <el-input
          v-model="form.department_list"
          placeholder="请选择部门"
          @focus="departmentShow"
          clearable
          @clear="getValueNull"
        ></el-input>
      <!--  <el-select v-model="form.department_list" @focus="departmentShow" @clear="getValueNull" clearable multiple placeholder="请选择部门">
          <el-option
            v-for="item in arre"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select> -->
      </el-form-item>
      <el-form-item>
        <el-button class="dsfdi" type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
      <div class="fr">
        <el-button type="info" plain @click="openDialog">批量分配任务</el-button>
      </div>
    </el-form>

    <el-table
      :data="tableData"
      @selection-change="handleSelectionChange"
      :row-key="getRowKeys"
      style="width: 100%;"
      stripe
    >
      <el-table-column type="selection" :selectable="selectable" :reserve-selection="true" width="65"> </el-table-column>
      <el-table-column label="员工" width="280" fixed>
       <template slot-scope="scope">
        <el-popover
          v-if="scope.row.name && scope.row.name.length > 10"
          placement="top-start"
          popper-class="popperBox"
          trigger="hover">
          <span>{{scope.row.name}}</span>
          <span slot="reference" style="color: #303133;">{{scope.row.name | ellipsis}}</span><span v-if="scope.row.status === 5" class="tag" size="mini" closable>离职</span>
            <span class="tag" v-if="scope.row.new_user_session_status === -1">存档关闭</span>
            <span class="tag01" v-if="scope.row.new_user_session_status === 1">存档</span>
            <span class="tag" v-if="scope.row.new_user_status === -1">离职</span>
        </el-popover>
        <span v-else>{{scope.row.name || '未知员工'}}</span>
          <span class="tag01" v-if="scope.row.new_user_session_status === 1">存档</span>
          <span class="tag" v-if="scope.row.new_user_session_status === -1">存档关闭</span>
          <span class="tag" v-if="scope.row.new_user_status === -1">离职</span>
        <div v-if="scope.row.name === '' || scope.row.name === null"><span>未知员工</span></div>
      </template>
      </el-table-column>
      <el-table-column label="部门" width="254">
        <template slot-scope="scope">
          <div v-if="scope.row.department_name && scope.row.department_name.length > 0">
            <el-popover
              v-if="scope.row.department_name.length > 16"
              placement="top-start"
              popper-class="popperBox"
              trigger="hover">
              <div>{{scope.row.department_name}}</div>
              <span slot="reference" style="color: #303133;">{{scope.row.department_name | ellipsiss}}</span>
            </el-popover>
            <span v-else>{{scope.row.department_name}}</span>
          </div>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="任务名称" width="334">
        <template slot-scope="scope">
        <div v-if="scope.row.task_name && scope.row.task_name.length > 0">
          <el-popover
            v-if="scope.row.task_name.length > 20"
            placement="top-start"
            popper-class="popperBox"
            trigger="hover">
            <div>{{scope.row.task_name}}</div>
            <span slot="reference" style="color: #303133;">{{scope.row.task_name | ellipsiss}}</span>
          </el-popover>
          <span v-else>{{scope.row.task_name}}</span>
          </div>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="任务数" min-width="150">
        <template slot="header">
          任务数
          <el-tooltip
            class="item"
            effect="dark"
            content="若设置任务比率，则任务数保留整数，舍弃小数"
            placement="top-start"
          >
            <i class="el-icon-question"></i>
          </el-tooltip>
        </template>
        <template slot-scope="scope">{{ scope.row.task_num}}</template>
      </el-table-column>
      <el-table-column label="更新时间" min-width="180">
        <template slot-scope="scope">{{scope.row.updated_at || '-'}}</template>
      </el-table-column>
      <el-table-column label="操作" width="150" fixed="right">
        <template slot="header">
          操作
          <el-tooltip
            class="item"
            effect="dark"
            content="分配的任务将在次日生效"
            placement="top-end"
          >
            <i class="el-icon-question"></i>
          </el-tooltip>
        </template>
        <template template slot-scope="scope">
          <el-button
            v-if="scope.row.status === 5 || scope.row.data_status === 3"
            type="text"
            disabled
            @click="handleEdit(scope.row)"
          >
            分配任务</el-button
          >
          <el-button
            v-else
            type="text"
            @click="handleEdit(scope.row)"
          >
            分配任务</el-button
          >
          <!-- <el-button
            type="text"
            class="hidden"
            @click="handleEdit(scope.row)"
            v-auth="['wordEdit']"
          >
            分配任务</el-button
          >
          >
          -->
        </template>
      </el-table-column>
      <template #empty>
        <el-empty  v-loading="loading"></el-empty>
      </template>
    </el-table>
    <!-- 选择员工 -->
    <el-dialog title="选择员工" :visible.sync="isSelectDialog" :show-close="false" :close-on-click-modal="false" width="600px" @open="clear">
      <el-row>
        <el-col :span="12">
          <el-card class="box-card" :body-style="{ height: '460px', overflow: 'auto' }" shadow="never" style="border-right: 1px solid #D8DCE1;">
            <el-input
              class="filter-input"
              placeholder="请输入人员名称"
              v-model="filterText"
              size="small"
              prefix-icon="el-icon-search"
              @input="dfhuh"
              @clear="gdfgf"
              clearable
            >
            </el-input>
            <div v-if="treeData01.length > 0 && treeData02.length === 0">
            <el-tree
              ref="tree"
              id="fixtree"
              :props="defaultProps"
              node-key="value"
              :check-on-click-node="true"
              :load="loadNode"
              :filter-node-method="filterNode"
              auto-expand-parent
              :default-checked-keys="peoples"
              lazy
              :check-strictly="true"
              @check-change="getChecked">
                <span class="custom-tree-node" slot-scope="{ data, node }">
                  <span v-if="data.isDepartment === false">
                    <img class="organization-img imgleft" src="../../../assets/images/zuzhi.png" style="width:14px;height:14px;" alt="">
                    <span v-if="data.is_show === true" style="color: #9D9D9D;">{{ data.label }}</span>
                    <span v-if="data.is_show === false">{{ data.label }}</span>
                  </span>
                  <span v-if="data.isDepartment === true">
                    <img v-if="data.label" class="organization-img" src="../../../assets/images/user.png" style="width:14px;height:14px;" alt="">
                    {{ data.label }}<span
                      v-if="node.checked && data.label"
                      style="margin-left: 10px;"
                      class="el-icon-check"
                    ></span>
                  </span>
                </span>
            </el-tree>
            </div>
            <ul class="infinite-lists" v-if="treeData02.length > 0" styel="z-index: 999;">
              <li v-for="(item, index) in treeData02" :key="index" @click="getChecked(item)" style="text-align:left;margin-top:10px;">
                  <img class="organization-img" src="../../../assets/images/user.png" style="width:14px;height:14px;" alt="">
                  <span style="margin-left:15px;">{{ item.label }} - {{ item.department_name}}</span>
              </li>
            </ul>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card" :body-style="{ height: '460px', overflow: 'auto' }" shadow="never">
            <div>已选择的员工</div>
            <ul class="infinite-list">
             <li v-for="item in checkedDimission" :key="item.id">
                <img class="organization-img" src="../../../assets/images/user.png" style="width:14px;height:14px;" alt="">
                <div :class="item.name.length <= 20 ? 'wqeq' : 'gfdgd'">{{ item.name }}</div>
                <div class="uiwe">
                  <i class="el-icon-close" @click="employeeClose(item)"></i>
               </div>
              </li>
            </ul>
          </el-card>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" plain @click="close">取消</el-button>
        <el-button style="width: 72px;" type="primary" :disabled="disabled01"  @click="reLoadTable">确定</el-button>
      </span>
    </el-dialog>

    <!-- 选择部门 -->
    <el-dialog title="选择部门" :visible.sync="departmentShow2" :show-close="false" :close-on-click-modal="false" width="600px">
      <el-row>
        <el-col :span="12" style="border-right: 1px solid rgba(216, 220, 225, 0.39);">
          <el-card class="box-card" :body-style="{ height: '460px', overflow: 'auto' }" shadow="never">
          <!--  <div slot="header">部门列表</div> -->
            <el-input
              class="filter-input"
              placeholder="搜索部门"
              v-model="filterText01"
              prefix-icon="el-icon-search"
              size="small"
              clearable
            >
            </el-input>
            <el-tree
              ref="treeDepartment"
              id="fixtree"
              :data="departmentData"
              node-key="value"
              :props="departmentProps"
              :check-on-click-node="true"
              @check-change="getDepart"
              :default-expanded-keys="departs"
              :default-checked-keys="departs"
              :filter-node-method="filterDepart"
              :check-strictly="true"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span>
                  <img class="imgleft" src="../../../../src/assets/images/zuzhi.png" style="width:14px;height:14px;" alt="">
                  <span v-if="data.is_show === true" style="color: 9D9D9D;">{{ data.label }}</span>
                  <span v-if="data.is_show === false">{{ data.label }}</span><span
                      v-if="node.checked"
                      style="margin-left: 10px;"
                      class="el-icon-check"
                    ></span>
                </span>
              </span>
            </el-tree>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card" :body-style="{ height: '460px', overflow: 'auto' }" shadow="never">
            <div class="xuanze">已选择的部门</div>
            <ul class="infinite-list">
              <li v-for="item in checkedDepartment" :key="item.id" style="display: flex;">
                <div style="width: 7%;"><img class="organization-img" src="../../../../src/assets/images/zuzhi.png" style="width:14px;height:14px;" alt=""></div>
                <div :class="item.label.length <= 20 ? 'dfsa' : 'dfsa01'"><span>{{ item.label }}</span></div>
                <div style="width: 6%;"><i class="el-icon-close" @click="empClose(item)"></i></div>
              </li>
            </ul>
          </el-card>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" plain @click="closeDepart">取消</el-button>
        <el-button style="width: 72px;" type="primary" :disabled="disabled2"  @click="reLoadDepart">确定</el-button>
      </span>
    </el-dialog>

    <div class="toolbar">
      <div></div>
      <el-pagination
        background
        @current-change="currentChange"
        :current-page="currentPage"
        :page-size="pagesize"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog title="批量分配任务" :show-close="false" :close-on-click-modal="false" :visible.sync="isRoleEdit" width="480px" style="margin-top: 12vh;">
      <el-form
        class="dialog-form"
        :model="fenForm"
        :rules="rules"
        label-width="120px"
        ref="fenForm"
        v-if="isRoleEdit"
        @submit.native.prevent
        style="margin-top: 30px;
        margin-left: 30px;
        margin-right: 20px;
        margin-bottom: 20px;"
      >
      <el-radio-group v-model="fenForm.id">
        <el-radio v-for="item in task_list" :key="item.id" :label="item.id">{{ item.name }}</el-radio>
      </el-radio-group>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" plain @click="disFaslse">取消</el-button>
        <el-button style="width: 72px;" type="primary" @click="allotTask('fenForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    this.id = []
    this.depapart_id = []
    return {
      getRowKeys(row) {
        return row.id
      },
      select_order_number: '',
      select_orderId: [],
      keywordForm: {
        name: '',
        task_name: ''
      },
      disabled2: true,
      currentPage: 1,
      pagesize: 10,
      disabled01: true,
      keyword: '',
      task_list: '',
      isRoleEdit: false,
      fenForm: {
        id: ''
      },
      treeData01: [],
      treeData02: [],
      defaultProps: {
        children: 'children',
        label: 'label',
        value: 'value',
        isLeaf: 'isHasChildren'
      },
      departmentProps: {
        children: 'child',
        label: 'label',
        value: 'value',
        disabled: 'is_show'
      },
      parent_id: 0,
      departmentData: [],
      checkedDimission: [],
      checkedDepartment: [],
      filterText: '',
      filterText01: '',
      isSelectDialog: false,
      departmentShow2: false,
      departs: [],
      rows: [],
      newArr: [],
      permissionList: [],
      tableData: [],
      loading: false,
      total: 0,
      form: {
        user_list: '',
        department_list: ''
      },
      multipleSelection: [],
      user_id: [],
      arr: [],
      people_id: '',
      arre: [],
      array: [],
      rules: {
        name: [{ required: true, message: '请输入敏感词', trigger: 'blur' }],
        content: [{ required: true, message: '请输入匹配规则', trigger: 'blur' }]
      },
      peoples: []
    }
  },
  mounted() {
    this.sfhusi()
    this.getList()
    this.getTask()
    this.getDepartment()
  },
  watch: {
    filterText(val) {
      if (val) {
        this.$refs.tree.filter(val)
      } else {
        this.treeData01 = []
        this.parent_id = 0
        this.sfhusi()
      }
    },
    filterText01(val) {
      if (val) {
        this.$refs.treeDepartment.filter(val)
      }
    },
    checkedDimission(val) {
      if (val.length > 0) {
        this.disabled01 = false
      } else {
        this.disabled01 = true
      }
    },
    checkedDepartment(val) {
      if (val.length > 0) {
        this.disabled2 = false
      } else {
        this.disabled2 = true
      }
    }
  },
  methods: {
    loadNode(node, resolve) {
      if (node === undefined || node.level === 0) {
        resolve(this.treeData01)
      } else {
        this.parent_id = node.data.value
        this.getChildrenNode()
        setTimeout(() => {
          resolve(this.treeData01)
        }, 1200)
      }
    },
    // 一级
    sfhusi() {
      this.$api.post('/api/v1/test/get-department', {
        user_id: sessionStorage.getItem('user_id'),
        parent_id: this.parent_id
      }).then(res => {
        this.treeData01 = res.return_data
      })
    },
    // 二级
    getChildrenNode() {
      this.$api.post('/api/v1/test/get-department', {
        user_id: sessionStorage.getItem('user_id'),
        parent_id: this.parent_id
      }).then(res => {
        if (res.return_data.length === 0) {
          res.return_data = [{ isDepartment: true }]
          this.treeData01 = res.return_data
        } else {
          this.chooseNode = 0
          this.treeData01 = res.return_data
        }
      })
    },
    gdfgf() {
      this.filterText = ''
      this.treeData01 = []
      // this.sfhusi()
    },
    getList() {
      this.loading = true
      const params = {
        user_list: this.id,
        department_list: this.depapart_id,
        page: this.currentPage
      }
      this.$api.get('/api/system/task/user/index', params).then((res) => {
        this.total = res.total
        this.tableData = res.data
        this.loading = false
      })
    },
    getTask() {
       this.$api.get('/api/system/task/active/task').then((res) => {
        this.task_list = res.data
      })
    },
    allotTask() {
      if (this.multipleSelection) {
        this.multipleSelection.forEach(item => {
          this.newArr.push(item.user_id)
        })
      }
      const params = {
        task_id: this.fenForm.id,
        user_id: this.newArr
      }
      this.$api.post('/api/system/task/user/bind', params).then((res) => {
        this.getList()
      })
      this.isRoleEdit = false
      this.newArr = []
    // /  this.getList()
    },
    disFaslse() {
      this.isRoleEdit = false
      this.getList()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
      this.select_order_number = this.multipleSelection.length
      if (val) {
        val.forEach(k => {
          this.select_orderId.push(k.id)
        })
      }
    },
    refresh() {
      this.getList()
    },
    handleEdit(row) {
      // if (this.multipleSelection.length === 0) {
      //   this.isRoleEdit = false
      //   this.$message.warning('请先勾选员工！')
      //   return
      // }
      this.fenForm.id = row.task_id
      this.newArr.push(row.user_id)
      this.isRoleEdit = true
    },
    checkUser2(e) {
      if (e !== 'close') {
        const arr = []
        const userid = []
        e.forEach(res => {
          arr.push(res.staff_name)
          userid.push(res.id)
        })
        this.searchForm = {
          ...this.searchForm,
          departmentNmae: arr.toString(),
          departmentId: userid
        }
      } else {
        this.searchForm = {
          ...this.searchForm,
          departmentNmae: '',
          departmentId: []
        }
      }
      this.departmentShow2 = false
    },
    onSearch() {
      this.currentPage = 1
      this.getList()
    },
    openDialog() {
      if (this.multipleSelection.length === 0) {
        this.isRoleEdit = false
        this.$message.warning('请先勾选员工！')
        return
      }
      this.isRoleEdit = true
    },
    currentChange(val) {
      this.tableData = []
      this.currentPage = val
      this.getList()
    },
    openSelectDialog() {
      this.id = []
      this.isSelectDialog = true
      this.parent_id = 0
    },
    setValueNull() {
      this.id = []
      this.filterText = ''
      this.treeData01 = []
      this.treeData02 = []
      this.checkedDimission = []
      this.parent_id = 0
      this.sfhusi()
      this.getList()
    },
    getChecked(value, isCheck) {
      if (value.isDepartment === true && value.value) {
        const checkedDimission = this.checkedDimission
        if (isCheck === false) {
          checkedDimission.forEach((item, i) => {
            if (item.id === value.value) {
              checkedDimission.splice(i, 1)
            }
          })
          return false
        }
        checkedDimission.forEach((item, i) => {
          if (item.id === value.value) {
            checkedDimission.splice(i, 1)
          }
        })
        if (value.department_name) {
           checkedDimission.push({
            id: value.value,
            name: value.label,
            show: 'false'
          })
        } else {
          checkedDimission.push({
            id: value.value,
            name: value.label
          })
        }
        this.checkedDimission = checkedDimission
      } else {
        this.checkedDimission.forEach(v => {
          this.peoples.push(v.id)
        })
        return false
      }
    },
    employeeClose(value) {
      this.checkedDimission.forEach((item, i) => {
        if (item.id === value.id) {
          if (value.show) {
            this.checkedDimission.splice(i, 1)
          } else {
            this.checkedDimission.splice(i, 1)
            this.$refs.tree.setChecked(value.id, false, true)
          }
        }
      })
    },
    empClose(value) {
      this.$refs.treeDepartment.setChecked(value.value, false)
    },
    reLoadTable() {
      const w = []
      if (this.checkedDimission.length > 0) {
          this.checkedDimission.forEach(v => {
          w.push(v.name)
          this.id.push(v.id)
        })
        this.form.user_list = w.toString()
        this.currentPage = 1
        this.getList()
        this.isSelectDialog = false
      } else {
        this.$message.warning('请选择员工')
      }
    },
    // tree过滤
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    close() {
      this.isSelectDialog = false
      this.form.user_list = ''
      this.treeData01 = []
      this.filterText = ''
      this.treeData02 = []
      this.checkedDimission = []
      this.parent_id = 0
      this.sfhusi()
      this.peoples = []
      this.getList()
    },
    departmentShow() {
      this.depapart_id = []
      this.departmentShow2 = true
    },
    getValueNull() {
      this.depapart_id = []
      this.getDepartment()
      this.getList()
    },
    // 获取部门表
    getDepartment() {
      this.$api.get('/api/v1/inherit/get-department', {
        user_id: sessionStorage.getItem('user_id')
      }).then(response => {
        let arr = []
        arr = response.data
        this.departmentData = arr || []
      })
    },
    closeDepart() {
      this.departmentShow2 = false
      this.filterText01 = ''
      this.form.department_list = ''
      this.getDepartment()
      // this.departmentData = []
      this.checkedDepartment = []
    },
    getDepart(value, isCheck) {
       const checkedDepartment = this.checkedDepartment
      if (isCheck) {
        checkedDepartment.push({
          label: value.label,
          value: value.value
        })
      } else {
        checkedDepartment.forEach((item, i) => {
          if (item.value === value.value) {
            checkedDepartment.splice(i, 1)
          }
        })
      }
      this.checkedDepartment = checkedDepartment
      this.checkedDepartment.forEach(k => {
        this.departs.push(k.id)
      })
    },
    departClose(value) {
       this.$refs.tree.setChecked(value.value, false)
    },
    reLoadDepart() {
      const r = []
      if (this.checkedDepartment.length > 0) {
        this.checkedDepartment.forEach(v => {
          r.push(v.label)
          this.depapart_id.push(v.value)
        })
        this.form.department_list = r.toString()
        this.currentPage = 1
        this.departmentShow2 = false
        this.getList()
      } else {
        this.$message.warning('请先选择部门')
      }
      // this.filterText01 = ''
    },
    selectable(row, index) {
      if (row.status === 5 || row.data_status === 3) {
        return false
      } else {
        return true
      }
    },
    // tree过滤
    filterDepart(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    dfhuh() {
      this.$api.post('/api/v1/test/get-user-department', {
        user_id: sessionStorage.getItem('user_id'),
        name: this.filterText
      })
      .then(res => {
        if (res.length === 0 || res.user_data.length === 0) {
          this.treeData02 = []
        } else {
          this.treeData02 = res.user_data
        }
      })
    },
    clear() {
      this.parent_id = 0
    }
  }
}
</script>
<style lang="scss" scoped>
>>> .small {
  position: relative;
  top: -82px;
  left: 110px;
  width: 220px;
  clear: both;
}
>>> .clear {
  clear: both;
}
>>> .yewio {
  margin-bottom: 0;
}
::v-deep .el-radio{
  margin-bottom: 10px;
  margin-right: 10px;
}
// .el-radio-group{
//   text-align: left;
//     padding: 0 30px;
// }
::v-deep .el-card {
  background: #ffffff;
  box-shadow: none;
  opacity: 1;
  border-radius: 2px;
  overflow: auto;
}
::v-deep .el-dialog .el-dialog__footer{
  text-align: right;
}
::v-deep .el-form-item__label {
    margin-top: 0px;
}
::v-deep .el-select .el-tag__close.el-icon-close{
  display: none;
}
v-deep .ty-main .ty-content.white{
  padding: 24px 20px
}
::v-deep.el-radio-group{
  padding: 0;
}
.el-button--primary.is-disabled{
  background: #F5F7FA;
}
::v-deep .el-dialog__body {
    padding:0;
}
::v-deep ul{
  // margin-top: 14px;
 // margin-left: -40px;
}
::v-deep .el-card{
  box-shadow: none;
}
.infinite-lists{
  padding: 10px;
  margin: 0;
}
.dsfd{
  text-align:left;
  margin-top: 10px;
  margin-left: -20px;
}
.filter-input {
  margin-bottom: 8px;
  line-height: 34px;
}
.dfsa{
  width: 87%;
  white-space:nowrap;
}
.dfsa01{
  width: auto;
  margin-right: 10px;
  white-space:nowrap;
}
</style>
